import React from 'react';
import { 
  FaBolt, FaDollarSign, FaTruck, FaEye, FaHome, FaBuilding, 
  FaMapMarkerAlt, FaPercentage, FaClock, FaCheckCircle 
} from 'react-icons/fa';
import { useLanguage } from '../../App';
import './QuickFilters.css';

const QuickFilters = ({
  type = 'projects', // 'projects' or 'units'
  onQuickFilterSelect,
  selectedFilters = [],
  className = ''
}) => {
  const { language } = useLanguage();

  const projectQuickFilters = [
    {
      id: 'available_now',
      label: language === 'ar' ? 'متاح الآن' : 'Available',
      icon: FaCheckCircle,
      filters: { status: ['ready'] },
      color: '#10b981'
    },
    {
      id: 'under_500k',
      label: language === 'ar' ? '<500K' : '<500K',
      icon: FaDollarSign,
      filters: { max_price: 500000 },
      color: '#3b82f6'
    },
    {
      id: 'ready_delivery',
      label: language === 'ar' ? 'جاهز' : 'Ready',
      icon: FaTruck,
      filters: { min_progress: 90 },
      color: '#f59e0b'
    },
    {
      id: 'has_virtual_tour',
      label: language === 'ar' ? 'جولة 360' : 'VR Tour',
      icon: FaEye,
      filters: { has_virtual_tour: true },
      color: '#8b5cf6'
    },
    {
      id: 'new_projects',
      label: language === 'ar' ? 'جديد' : 'New',
      icon: FaBolt,
      filters: { launch_date_from: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] },
      color: '#ef4444'
    },
    {
      id: 'riyadh_projects',
      label: language === 'ar' ? 'الرياض' : 'Riyadh',
      icon: FaMapMarkerAlt,
      filters: { city: 'الرياض' },
      color: '#06b6d4'
    }
  ];

  const unitQuickFilters = [
    {
      id: 'available_units',
      label: language === 'ar' ? 'متاح' : 'Available',
      icon: FaCheckCircle,
      filters: { sales_status: ['Available'] },
      color: '#10b981'
    },
    {
      id: 'under_300k',
      label: language === 'ar' ? '<300K' : '<300K',
      icon: FaDollarSign,
      filters: { max_price: 300000 },
      color: '#3b82f6'
    },
    {
      id: 'villas',
      label: language === 'ar' ? 'فلل' : 'Villas',
      icon: FaHome,
      filters: { property_type: 'فيلا' },
      color: '#8b5cf6'
    },
    {
      id: 'apartments',
      label: language === 'ar' ? 'شقق' : 'Apartments',
      icon: FaBuilding,
      filters: { property_type: 'شقة' },
      color: '#06b6d4'
    },
    {
      id: 'large_area',
      label: language === 'ar' ? 'مساحة كبيرة' : 'Large',
      icon: FaHome,
      filters: { min_area: 500 },
      color: '#84cc16'
    },
    {
      id: 'sea_view',
      label: language === 'ar' ? 'إطلالة بحر' : 'Sea View',
      icon: FaEye,
      filters: { view: 'بحر' },
      color: '#0ea5e9'
    }
  ];

  const quickFilters = type === 'projects' ? projectQuickFilters : unitQuickFilters;

  const isFilterSelected = (filterId) => {
    return selectedFilters.includes(filterId);
  };

  const handleQuickFilterClick = (filter) => {
    if (onQuickFilterSelect) {
      onQuickFilterSelect(filter.id, filter.filters);
    }
  };

  return (
    <div className={`quick-filters ${language === 'ar' ? 'rtl' : 'ltr'} ${className}`}>
      <div className="quick-filters-header">
        <h4 className="quick-filters-title">
          <FaBolt className="title-icon" />
          {language === 'ar' ? 'فلاتر سريعة' : 'Quick Filters'}
        </h4>
      </div>
      
      <div className="quick-filters-grid">
        {quickFilters.map((filter) => {
          const IconComponent = filter.icon;
          const isSelected = isFilterSelected(filter.id);
          return (
            <button
              key={filter.id}
              className={`quick-filter-btn ${isSelected ? 'selected' : ''}`}
              onClick={() => handleQuickFilterClick(filter)}
              style={{ '--filter-color': filter.color }}
            >
              <IconComponent className="filter-icon" />
              <span className="filter-label">{filter.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickFilters;
